module.exports = __webpack_public_path__ + "img/banner.e3855de3.png";